import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '@/hooks';
import { ReactComponent as OnyxLogoBlack } from '@/assets/images/ONYX-Logo-Black.svg';

const AuthError: React.FC = () => {
  const navigate = useNavigate();
  const { error, logout } = useAuth();

  const handleRetry = async () => {
    // Log out and redirect to login
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white dark:bg-gray-800 shadow-xl rounded-lg p-8 border border-gray-200 dark:border-gray-700">
          {/* ONYX Logo */}
          <div className="mb-6">
            <OnyxLogoBlack className="h-10 w-auto mx-auto dark:filter dark:invert" />
          </div>

          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-onyx-red/10 dark:bg-onyx-red/20 mb-4">
            <ExclamationTriangleIcon className="h-10 w-10 text-onyx-red" />
          </div>

          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 onyx-headline">
            Authentication Error
          </h1>

          <p className="text-gray-600 dark:text-gray-400 mb-6 onyx-body">
            {error ||
              'Unable to verify your permissions. This may be due to a temporary issue with our servers.'}
          </p>

          <div className="space-y-4">
            <button
              onClick={handleRetry}
              className="w-full px-4 py-2 bg-onyx-bright-blue text-white font-fk-medium rounded-lg hover:bg-onyx-dark-blue transition-colors focus:outline-none focus:ring-2 focus:ring-onyx-bright-blue focus:ring-offset-2 onyx-button"
            >
              Sign In Again
            </button>

            <p className="text-sm text-gray-500 dark:text-gray-400 onyx-body">
              If this problem persists, please contact{' '}
              <a
                href="mailto:support@onyxinsight.com"
                className="text-onyx-bright-blue hover:text-onyx-dark-blue underline transition-colors"
              >
                support@onyxinsight.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthError;
